import ReactGA from 'react-ga';

import React, { Component } from 'react';
import { TwitterPicker } from 'react-color';
import download from 'downloadjs';
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import {
  FacebookShareButton,
  FacebookMessengerShareButton,
  RedditShareButton,
  TwitterShareButton,
} from "react-share";
import {
  FacebookIcon,
  FacebookMessengerIcon,
  RedditIcon,
  TwitterIcon,
} from "react-share";

import './App.css';

class App extends Component {
  fonts = [
    'Tiresias Infofont',
    'Tahoma',
    'Aardvark Cafe',
  ]

  state = {
    width: 800,
    title: 'Caption title',
    title_size: '64',
    caption: `You can write your own captions. Find a picture online and paste it in the url slot. After that you can tinker with the options and download the image to your device. I accept most image formats and some video formats and it's completely up to you what kind of caption you create.`,
    tagline: 'Tag or watermark me',
    tagline_size: '24',
    gif_url: '',
    gif_height_adjust: '35',
    signoff: '- Signing off',
    accentColor: '#dd2bbc',
    captionBoxColor: '#ffc0cb',
    text_color: '#ffffff',
    glow: false,
    caption_box: true,
    read_only: false,
    rendering: false,
    title_font: this.fonts[0],
    caption_font: this.fonts[1],
    is_image: false,
    image_error: false,
    share_url: 'https://captionmaker.dev/'
  }

  constructor() {
    super();
    try {
      const url = new URL(window.location.href);
      const read_only = url.searchParams.get('read_only') || false;
      this.state = {
        ...this.state,
        read_only: read_only,
      };

      const data = url.searchParams.get('data');
      const save_data = JSON.parse(Buffer.from(data, 'base64'));
      const {
        title,
        caption,
        tagline,
        gif_url,
        gif_height_adjust,
        signoff,
        accentColor,
        glow,
        caption_box,
        captionBoxColor,
        text_color,
        rendering,
        title_font,
        caption_font,
        is_image,
        image_error,
      } = save_data;
      this.state = {
        ...this.state,
        title,
        caption,
        tagline,
        gif_url,
        gif_height_adjust,
        signoff,
        read_only,
        accentColor,
        glow,
        caption_box,
        captionBoxColor,
        text_color,
        rendering,
        title_font,
        caption_font,
        is_image,
        image_error,
      };
    } catch {}
  }

  componentDidMount() {
    // need to defer loading to load font
    ReactGA.initialize('UA-50869087-6');
    ReactGA.pageview(window.location.pathname + window.location.search);
    if (isMobile) {
      this.setState({
        width: 350,
        title_size: 32,
      });
    }
    window.addEventListener('load', this.draw);
    this.setGif();
    const url = new URL(window.location.href);
    const data = url.searchParams.get('data');
    if (data == null) {
      this.slowType(` We do not store any of the images on our servers, so feel free to be as creative as you want.`);
    }
    this.textArea.focus();
    setInterval(this.poll, 50);
  }

  setGif() {
    fetch('/gif', {
      method: 'get',
    })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (data.gif_url) {
        this.setState({ gif_url: data.gif_url})
      }
    })
    .catch((error) => {
      this.setState({
        gif_url: 'https://c.tenor.com/ML4qkLFXYJMAAAAd/skater-skater-girl.gif'
      })
      console.info('Could not fetch gif.');
    })
  }

  poll = () => {
    this.forceUpdate();
  }

  slowType(text) {
    if (text.length === 0) {
      return;
    }
    setTimeout(
      () => {
        this.setState(
          prevState => ({caption: prevState.caption + text[0]}),
          () => {
            this.slowType(text.substr(1));
          },
        );
      },
      10,
    );
  }

  componentWillUnmount() {
    // need to defer loading to load font
    window.removeEventListener('load', this.draw);
  }

  componentDidUpdate() {
    this.draw();
  }

  getGifHeight() {
    const gif_height = ((this.gif && this.gif.offsetHeight) || 400)
      - (parseInt(this.state.gif_height_adjust || 0));
    return gif_height;
  }

  getHeight() {
    if (!this.ctx) {
      return 1;
    }
    return this.getGifHeight() + 8 + (this.getCaptionLines().length) * 29 + 48;
  }

  draw = () => {
    this.ctx.clearRect(0, 0, this.state.width, this.getHeight());
    this.drawTitle();
    this.drawTagline();
    if (this.state.caption_box) {
      this.drawCaptionBox(this.getGifHeight());
      this.drawCaption();
      this.drawSignoff();
    }
  }

  getCaptionLines() {
    const text = this.state.caption.replace(/\n+\s*/g, '\n\n    ').trim();
    const max_width = this.state.width - 30;
    const textBlocks = text.split('\n');
    const lines = [];

    textBlocks.forEach(text => {
      var words = text.split(" ");
      var currentLine = words[0];
      for (var i = 1; i < words.length; i++) {
        var word = words[i];
        var width = this.ctx.measureText(currentLine + " " + word).width;
        if (width < max_width) {
          currentLine += " " + word;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }
      lines.push(currentLine);
    });
    lines.push('');
    return lines;
  }

  measureText(pText, pFontSize, pStyle) {
    var lDiv = document.createElement('div');

    document.body.appendChild(lDiv);

    if (pStyle != null) {
        lDiv.style = pStyle;
    }
    lDiv.style.fontSize = "" + pFontSize + "px";
    lDiv.style.position = "absolute";
    lDiv.style.left = -1000;
    lDiv.style.top = -1000;

    lDiv.innerHTML = pText;

    var lResult = {
        width: lDiv.clientWidth,
        height: lDiv.clientHeight
    };

    document.body.removeChild(lDiv);
    lDiv = null;

    return lResult;
  }

  drawTitle() {
    const text = this.state.title;
    var x = 16;
    var y = 13;
    this.ctx.font = "bold " + this.state.title_size + "px " + this.state.title_font;
    this.ctx.textAlign = 'left';
    this.ctx.textBaseline = 'top';
    this.ctx.fillStyle = this.state.text_color;
    if (this.state.accentColor && this.state.glow) {
      this.ctx.strokeStyle = this.state.accentColor;
      this.ctx.shadowColor = this.state.accentColor;
      this.ctx.shadowBlur = 12;
      this.ctx.lineWidth = 5;
      this.ctx.miterLimit = 8;
      this.ctx.strokeText(text, x, y);
    }
    this.ctx.fillText(text, x, y);
    this.ctx.textBaseline = 'alphabetic';
  }

  drawTagline() {
    const text = this.state.tagline;
    this.ctx.font = this.state.tagline_size + "px " + this.state.title_font;
    this.ctx.fillStyle = this.state.text_color;
    const x = this.state.width - 8;
    const y = this.getGifHeight() - 20;
    this.ctx.fillStyle = this.state.text_color;
    this.ctx.textAlign = 'right';
    if (this.state.accentColor && this.state.glow) {
      this.ctx.strokeStyle = this.state.accentColor;
      this.ctx.shadowColor = this.state.accentColor;
      this.ctx.shadowBlur = 2;
      this.ctx.miterLimit = 4;
      this.ctx.lineWidth = 2;
      this.ctx.strokeText( text, x, y);
    }
    this.ctx.fillText( text, x, y );
  }

  drawCaptionBox(y) {
    this.ctx.shadowBlur = 0;
    this.ctx.fillStyle = this.state.captionBoxColor;
    this.ctx.fillRect(0, y, 2000, 2000);
  }

  drawCaption() {
    this.ctx.font = "bold 24px " + this.state.caption_font;
    if (this.state.accentColor && this.state.glow) {
      this.ctx.strokeStyle = this.state.accentColor;
      this.ctx.shadowColor = this.state.accentColor;
      this.ctx.shadowBlur = 2;
      this.ctx.miterLimit = 8;
      this.ctx.lineWidth = 4;
    }
    this.ctx.fillStyle = this.state.text_color;
    const lines = this.getCaptionLines();
    const y = this.getGifHeight();
    const fontSize = 24;
    this.ctx.fillStyle = this.state.text_color;
    this.ctx.textAlign = 'left';
    for (let i=0, j=lines.length; i<j; ++i ) {
      if (this.state.accentColor && this.state.glow) {
        this.ctx.strokeText( lines[i], 16, y + fontSize + (fontSize+5) * i + 12);
      }
      this.ctx.fillText( lines[i], 16, y + fontSize + (fontSize+5) * i + 12);
    }
  }

  drawSignoff() {
    const text = this.state.signoff;
    this.ctx.font = "bold 24px " + this.state.caption_font;
    this.ctx.fillStyle = this.state.text_color;
    const x = this.state.width - 16;
    const fontSize = 24;
    const y = this.getGifHeight() + 12;
    const num_lines = this.getCaptionLines().length;
    this.ctx.fillStyle = this.state.text_color;
    this.ctx.textAlign = 'right';
    if (this.state.accentColor && this.state.glow) {
      this.ctx.strokeStyle = this.state.accentColor;
      this.ctx.miterLimit = 8;
      this.ctx.shadowColor = this.state.accentColor;
      this.ctx.shadowBlur = 2;
      this.ctx.lineWidth = 4;
      this.ctx.strokeText( text, x, y + fontSize + (fontSize+5) * num_lines );
    }
    this.ctx.fillText( text, x, y + fontSize + (fontSize+5) * num_lines );
  }

  _isImage() {
    fetch(this.state.gif_url, {
      // mode: 'no-cors',
      referrer: '',
      method: 'get',
      headers: {
        'user-agent': 'Mozilla/4.0 MDN Caption Maker',
      }
    })
    .then(r => r.blob())
    .then(d => {
      console.log('d:', d);
      // const urlCreator = window.URL || window.webkitURL;
      // const imageUrl = urlCreator.createObjectURL(d);
      this.setState({ is_image: d.type.includes('image/') })
    })
  }

  _renderContent() {
    const url = this.state.gif_url.split('?')[0];
    if (url.substr(-5) === '.webm' || url.substr(-4) === '.mp4') {
      return (
        <video
          ref={ref => {
            if (ref) {
              this.gif = ref;
            }
          }}
          className="gif"
          width={this.state.width}
          playsInline
          autoPlay
          muted
          loop
        >
          <source src={this.state.gif_url} type="video/mp4" />
        </video>
      )
    } else if (
      (url.substr(-4) === '.gif'
      || url.substr(-4) === '.png'
      || url.substr(-4) === '.jpg'
      || url.substr(-5) === '.jpeg'
      || this.state.is_image)
      && !this.state.image_error
    ) {
      return (
        <img
          alt="preview"
          ref={ref => {
            if (ref) {
              this.gif = ref;
            }
          }}
          className="gif"
          width={this.state.width}
          referrerPolicy="no-referrer"
          src={this.state.gif_url}
          onError={() => {
            this.setState({ image_error: true })
          }}
        />
      )
    } else {
      return (
        <div
          ref={ref => {
            if (ref) {
              this.gif = ref;
            }
          }}
          className="gif"
          style={{display: 'table', height: '400px'}}
        >
          <div
            style={{display: 'table-cell', verticalAlign: 'middle'}}
          >
             I'm so sorry, I can't render that filetype or source returns forbidden.
          </div>
        </div>
      )
    }
  }

  getWidth() {
    return this.state.width;
  }

  _renderPreview() {
    return (
      <div className="preview">
        {this._renderContent(this.state.gif_url)}
        <canvas
          ref={ref => {
            if (ref) {
              this.canvas = ref;
              this.ctx = ref.getContext('2d');
            }
          }}
          width={this.getWidth()}
          height={this.getHeight()}
        />
      </div>
    );
  }

  getFile(data) {
    fetch('/download?id=' + data.job_id + '&filename=' + data.filename, {
      method: 'get',
      responseType:'arraybuffer'
    })
    .then(async (response) => {
      if (response.status === 200) {
        download(await response.blob(), data.filename);
      }
    })
    .catch(() => {
    })
    .finally(() => {
      this.setState({ rendering: false });
    });
  }

  getStatus(data) {
    fetch('/status?id=' + data.job_id, {
      method: 'get',
    })
    .then((response) => {
      if (response.ok) {
        response.json()
        .then((status) => {
          if (status.status === 'failed') {
            // notify user of error
            this.setState({ rendering: false });
            return false;
          }
          if (status.status !== 'succeeded') {
            setTimeout(() => {
              this.getStatus(data);
            }, 3000);
          }
          if (status.status === 'succeeded') {
            this.getFile(data);
          }
        })
      } else {
        this.setState({ rendering: false });
      }
    })
    .catch((error) => {
      ('Could not download file');
      this.setState({ rendering: false });
    });
  }

  changeGif(event) {
    this.setState({gif_url: event.target.value})
    // dirty hack
    setTimeout(() => {
      this._isImage();
    }, 500);
  }

  render() {

    const {
      title,
      title_size,
      caption,
      tagline,
      tagline_size,
      gif_url,
      gif_height_adjust,
      signoff,
      accentColor,
      captionBoxColor,
    } = this.state;
    const save_data = {
      title,
      title_size,
      caption,
      tagline,
      tagline_size,
      gif_url,
      gif_height_adjust,
      signoff,
      accentColor,
      captionBoxColor,
    };

    // eslint-disable-next-line no-unused-vars
    const save_link = Buffer.from(JSON.stringify(save_data)).toString("base64");

    return (
      <div className="main">
        <div className="content">
          <h1 className="title">
            Caption Maker
          </h1>
          <BrowserView>
            <div className="instructions">
              <h2 style={{
                width: '170px',
                marginTop: '-10px',
                paddingBottom: '20px'
              }}>Create free custom captions for images and gifs</h2>
              <h2 style={{
                color: '#ff7575',
              }}>Instructions:</h2>
              <h2>1. Paste url</h2>
              <h2>2. Tweak options</h2>
              <h2>3. Download caption</h2>
              <h2 style={{
                marginTop: '10px',
                color: '#ff7575'
              }}>Accepted formats:</h2>
              <h2>.webm, .mp4</h2>
              <h2>.gif, .png, .webp, .jpeg</h2>
            </div>
          </BrowserView>
          <MobileView>
            <p style={{
              margin: '0 10px 50px 10px',
              fontSize: '0.8rem',
            }}>We have noticed you're on your mobile device.
              The site should work, but it's not optimized for mobile use and the
              caption might come out weird.</p>
          </MobileView>
          <div className="input" style={{
            position: 'relative',
            top: '-25px',
            marginTop: 0,
          }}>
            <span>
              url
            </span>
            <input
              type="text"
              onChange={event => this.changeGif(event)}
              value={this.state.gif_url}
              style={{
                width: '400px',
              }}
            />
          </div>
          <>
            <div className="input">
              <span>
                title
              </span>
              <input
                type="text"
                onChange={event => this.setState({title: event.target.value})}
                value={this.state.title}
              />
            </div>
            <div className="input">
              <span>
                title size
              </span>
              <input
                type="range"
                style={{
                  width: '364px',
                  background: 'transparent',
                  marginBottom: '0',
                  marginTop: '0',
                }}
                min="8"
                max="99"
                onChange={event => this.setState({title_size: event.target.value})}
                value={this.state.title_size}
              />
              <input
                type="text"
                style={{
                  width: '25px',
                  marginLeft: '10px',
                  textAlign: 'center',
                }}
                min="8"
                max="99"
                onChange={event => this.setState({title_size: event.target.value})}
                value={this.state.title_size}
              />
            </div>
            <div className="input">
              <span>
                tagline
              </span>
              <input
                type="text"
                onChange={event => this.setState({tagline: event.target.value})}
                value={this.state.tagline}
              />
            </div>
            <div className="input">
              <span>
                tagline size
              </span>
              <input
                type="range"
                style={{
                  width: '364px',
                  background: 'transparent',
                  marginBottom: '0',
                  marginTop: '0',
                }}
                min="8"
                max="99"
                onChange={event => this.setState({tagline_size: event.target.value})}
                value={this.state.tagline_size}
              />
              <input
                type="text"
                style={{
                  width: '25px',
                  marginLeft: '10px',
                  textAlign: 'center',
                }}
                min="8"
                max="99"
                onChange={event => this.setState({tagline_size: event.target.value})}
                value={this.state.tagline_size}
              />
            </div>
            <div className="input">
              <span>
                glow?
              </span>
              <input
                onChange={event => this.setState(prevState => ({glow: !prevState.glow}))}
                name="isGlow"
                type="checkbox"
                checked={this.state.glow}
                style={{
                  width: '50px',
                  marginLeft: '0',
                  marginRight: '377px',
                }}
              />
            </div>
            <div className="input">
              <span style={{
                margin: '0 22px 0 0',
              }}>
                glow color
              </span>
              <BrowserView>
                <TwitterPicker
                  width={407}
                  color={ this.state.accentColor }
                  onChangeComplete={ color => this.setState({accentColor: color.hex}) }
                  triangle={false}
                  colors={['#1d61d1', '#00D084', '#acdeff', '#EB144C', '#ffc0cb', '#800080', '#dd2bbc']}
                />
              </BrowserView>
              <MobileView>
                <TwitterPicker
                  width={407}
                  color={ this.state.accentColor }
                  onChangeComplete={ color => this.setState({accentColor: color.hex}) }
                  triangle={false}
                  colors={['#1d61d1', '#00D084', '#EB144C', '#ffc0cb', '#800080', '#dd2bbc']}
                />
              </MobileView>
            </div>
            <div className="input">
              <span>
                caption box?
              </span>
              <input
                onChange={event => this.setState(prevState => ({caption_box: !prevState.caption_box}))}
                name="isCaptionBox"
                type="checkbox"
                checked={this.state.caption_box}
                style={{
                  width: '50px',
                  marginLeft: '0',
                  marginRight: '377px',
                }}
              />
            </div>
            <div className="input">
              <span style={{
                margin: '0 22px 0 0',
              }}>
                caption box color
              </span>
              <BrowserView>
                <TwitterPicker
                  width={407}
                  color={ this.state.captionBoxColor }
                  onChangeComplete={ color => this.setState({captionBoxColor: color.hex}) }
                  triangle={false}
                  colors={['#FFFFFF', '#00D084', '#acdeff', '#EB144C', '#ffc0cb', '#ac62f4', '#0e1111']}
                />
              </BrowserView>
              <MobileView>
                <TwitterPicker
                  width={407}
                  color={ this.state.captionBoxColor }
                  onChangeComplete={ color => this.setState({captionBoxColor: color.hex}) }
                  triangle={false}
                  colors={['#FFFFFF', '#acdeff', '#EB144C', '#ffc0cb', '#ac62f4', '#0e1111']}
                />
              </MobileView>
            </div>
            <div className="input">
              <span style={{
                margin: '0 22px 0 0',
              }}>
                text color
              </span>
              <BrowserView>
                <TwitterPicker
                  width={407}
                  color={ this.state.text_color }
                  onChangeComplete={ color => this.setState({text_color: color.hex}) }
                  triangle={false}
                  colors={['#FFFFFF', '#00D084', '#acdeff', '#EB144C', '#ffc0cb', '#ac62f4', '#0e1111']}
                />
              </BrowserView>
              <MobileView>
                <TwitterPicker
                  width={407}
                  color={ this.state.text_color }
                  onChangeComplete={ color => this.setState({text_color: color.hex}) }
                  triangle={false}
                  colors={['#FFFFFF', '#acdeff', '#EB144C', '#ffc0cb', '#ac62f4', '#0e1111']}
                />
              </MobileView>
            </div>
            <div className="input">
              <span>
                caption box offset
              </span>
              <input
                type="range"
                style={{
                  width: '364px',
                  background: 'transparent',
                  marginBottom: '0',
                  marginTop: '0',
                }}
                min="8"
                max="99"
                onChange={event => this.setState({gif_height_adjust: event.target.value})}
                value={this.state.gif_height_adjust}
              />
              <input
                type="text"
                style={{
                  width: '25px',
                  marginLeft: '10px',
                  textAlign: 'center',
                }}
                min="8"
                max="99"
                onChange={event => this.setState({gif_height_adjust: event.target.value})}
                value={this.state.gif_height_adjust}
              />
            </div>
            <div className="input">
              <span style={{
                marginRight: '18px',
              }}>
                title font
              </span>
              <select
                className="minimal"
                onChange={event => this.setState(prevState => ({title_font: event.target.value}))}
                name="isFontSelectMain"
                value={this.state.title_font}
                style={{
                  width: '412px',
                }}
              >
                { this.fonts && this.fonts.map((font) => {
                  return <option value={font}>{font}</option>
                }) }
              </select>
            </div>
            <div className="input">
              <span style={{
                marginRight: '18px',
              }}>
                caption font
              </span>
              <select
                className="minimal"
                onChange={event => this.setState(prevState => ({caption_font: event.target.value}))}
                name="isFontSelectMain"
                value={this.state.caption_font}
                style={{
                  width: '412px',
                }}
              >
                { this.fonts && this.fonts.map((font) => {
                  return <option value={font}>{font}</option>
                }) }
              </select>
            </div>
          </>
          <textarea
            ref={ref => {
              if (ref) {
                this.textArea = ref;
              }
            }}
            onChange={event => this.setState({caption: event.target.value})}
            value={this.state.caption}
          />
          <div className="input">
            <input
              type="text"
              onChange={event => this.setState({signoff: event.target.value})}
              value={this.state.signoff}
            />
          </div>
          <div class="input">
            <span style={{
              margin: '0 22px 0 0',
              fontSize: '0.8rem',
            }}>{ this.state.rendering
               ? 'We are trying to find you a worker. Please wait...'
               : ''}</span>
            <button disabled={this.state.rendering} onClick={() => {
              this.setState({ rendering: true });
              fetch('/render', {
                method: 'post',
                headers: { 'Content-type': 'application/json' },
                body: JSON.stringify({
                  url: this.state.gif_url,
                  canvas: this.canvas.toDataURL("image/png")
                })
              })
              .then((response) => {
                if (response.ok) {
                  response.json()
                  .then((data) => {
                    this.getStatus(data);
                  })
                }
              })
              .catch((error) => {
                this.setState({ rendering: false });
              });
            }}>{ this.state.rendering ? 'Processing...' : 'Download' }</button>
          </div>
          {this._renderPreview()}
        </div>
        <div className="footer">
          <div className="footer-content">
            <h4>Share me</h4>
            <FacebookShareButton url={this.state.share_url}>
              <FacebookIcon size={32} round={true} />
            </FacebookShareButton>
            <FacebookMessengerShareButton url={this.state.share_url}>
              <FacebookMessengerIcon size={32} round={true} />
            </FacebookMessengerShareButton>
            <TwitterShareButton url={this.state.share_url}>
              <TwitterIcon size={32} round={true} />
            </TwitterShareButton>
            <RedditShareButton url={this.state.share_url}>
              <RedditIcon size={32} round={true} />
            </RedditShareButton>
          </div>
          <div className="footer-content">
            <h4>Donate</h4>
            <a href={'https://www.buymeacoffee.com/thedeveloper'} target="_blank" rel="noreferrer">
              <img className="buymecoffee" src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" alt="Buy Me A Coffee" />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
